import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface Pesv {
  cedula?: string;
  nombre?: string;
  documento?: number;
}

@Injectable({
  providedIn: 'root',
})
export class PesvService {
private apiUrl =  `${environment.apiUrl}/api/pesv`; 
  constructor(private http: HttpClient) {}

  // Encabezados para POST requests
  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }

  // GET: Obtener todos los registros
  getPesv(): Observable<any> {
    return this.http
      .get(this.apiUrl, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  // GET: Obtener un registro por cédula
  getPesvByCedula(cedula: string): Observable<any> {
    return this.http
      .get(`${this.apiUrl}/${cedula}`, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  // POST: Crear nuevo registro
  createPesv(data: {
    cedula: string;
    nombre: string;
    cargo: string;
    funcion: string;
    tipo_vinculo?: string;
    fecha_designacion?: string;
    fecha_vencimiento?: string;
    documento?: number;
    creado_por?: string;
    fecharegistro?: string;
  }): Observable<any> {
    return this.http
      .post(this.apiUrl, data, { headers: this.getHeaders(), withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  // Manejo de errores
  private handleError(error: any): Observable<never> {
    console.error('Error en servicio Pesv:', error);
    return throwError(() => error);
  }

    // PUT: Inactivar un registro por ID
  getPesvInactivate(id: string): Observable<any> {
    return this.http
      .put(`${this.apiUrl}/inactivar/${id}`, {}, { headers: this.getHeaders(), withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  // GET: Verificar si existe un líder activo
  checkLiderActivo(): Observable<any> {
    return this.http
      .get(`${this.apiUrl}/activo/verificar`, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  // GET: Obtener el líder PESV activo
  getLiderActivo(): Observable<any> {
    return this.http
      .get(`${this.apiUrl}/lider-activo`, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  getPesvBypdf(id: string): Observable<any> {
    return this.http
      .get(`${this.apiUrl}/pdf/${id}`, { withCredentials: true })
      .pipe(catchError(this.handleError));
  }
}